import toggleScroll from '../utils/toggle-body-scroll';
import store from 'store';
import {ROOT_ELEMENT, ROOT_CLASS} from '../constants';

const STORAGE_KEY = 'hasConfirmedCookies';
const STORAGE_VALUE = 'true';

document.addEventListener('DOMContentLoaded', () => {
    if (store.get(STORAGE_KEY)) return;

    const cookies = document.createElement('div');
    cookies.className = 'cookies';

    cookies.innerHTML = '<div class="info-box">' +
        '<h3>Cookies</h3>' +
        '<p>This website uses cookies. By continuing to browse the site you are agreeing to our use of cookies. ' +
        '<a href="cookies.html">Find out more</a>' +
        '</p>' +
        '<div class="info-action">' +
        '<button>Got it</button>' +
        '</div>' +
        '</div>';

    document.body.appendChild(cookies);


    ROOT_ELEMENT.addEventListener('preloaderEnd', () => {
        if (!$('.js-cookies').length) {
            toggleCookiesMessage(true);
        }
    });

    const button = cookies.querySelector('button');

    button.addEventListener('click', () => {
        store.set(STORAGE_KEY, STORAGE_VALUE);
        toggleCookiesMessage(false);

        setTimeout(() => {

            cookies.parentElement.removeChild(cookies);

        }, 1000);
    });

    function toggleCookiesMessage(isOpened) {

        ROOT_ELEMENT.classList.toggle(ROOT_CLASS + '_has-cookies', isOpened);

        toggleScroll(isOpened);

    }
});


// WEBPACK FOOTER //
// ./scripts/elements/cookies.js